import apiClient, { setTokens, clearTokens } from "@/lib/api-client"
import type { LoginRequest, LoginResponse, User } from "@/types/api"

export const authService = {
  // Login
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>("/users/login/", data)

    // Store tokens
    setTokens(response.access, response.refresh)

    return response
  },

  // Logout
  logout: async (): Promise<void> => {
    try {
      await apiClient.post("/users/logout/")
    } finally {
      clearTokens()
    }
  },

  // Get current user profile
  getProfile: async (): Promise<User> => {
    return apiClient.get<User>("/users/profile/")
  },

  // Refresh token
  refreshToken: async (refresh: string): Promise<{ access: string }> => {
    return apiClient.post<{ access: string }>(
      "/users/token-refresh/",
      { refresh }
    )
  },
}
